module.exports = __webpack_public_path__ + "static/media/16.03c4562a.jpg";